import { OwlOptions } from 'ngx-owl-carousel-o';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { ListsService } from 'src/app/services/lists.service';
import { Subject, take, takeUntil } from 'rxjs';
import { ICreateListModal, Topic } from '@models/lists.model';
import { SnackbarService } from '@services/snackbar.service';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';


@Component({
  selector: 'app-create-list-modal',
  templateUrl: './create-list-modal.component.html',
  styleUrls: ['./create-list-modal.component.scss'],
  standalone: true,
  imports: [LottieComponent, MatFormFieldModule, MatIconModule, MatDialogModule, FormsModule, ReactiveFormsModule, MatInputModule, MatSelectModule, MatOptionModule, MatButtonModule, TranslateModule]
})
export class CreateListModalComponent implements OnInit, OnDestroy {

  public nameList: UntypedFormGroup;
  public loading = false;
  public imagesLoading = true;
  public imagesArr: any[] = [];
  public selectedPictureId: any;
  public urlTemporal = '../../assets/images/help.png';
  public options: AnimationOptions = {
    path: '/assets/animations/loader.json',
  };
  public imageSelected = '';
  public customOptions: OwlOptions = {
    loop: false,
    autoplay: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    slideBy: 'page',
    navSpeed: 700,
    margin: 38,
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      740: {
        items: 3
      },
      940: {
        items: 3
      },
      1300: {
        items: 3
      },
      1900: {
        items: 3
      }
    },
    nav: false
  };
  public topicsArr: Topic[] = [];
  private subs = new Subject<void>();

  constructor(
    private fb: UntypedFormBuilder,
    private listsService: ListsService,
    private router: Router,
    private dialogRef: MatDialogRef<CreateListModalComponent>,
    private snackbarService: SnackbarService,
    @Inject(MAT_DIALOG_DATA) public data: ICreateListModal
  ) {
    this.createForm();
  }

  ngOnInit(): void {
    this.getTopics();
    if (this.data) {
      this.setEditValues();
    }
    this.nameList.get('topic')?.valueChanges.pipe(takeUntil(this.subs)).subscribe((res: string) => {
      const topic = this.topicsArr.find((topic: Topic) => topic.topic === res);
      if (topic?.picture) this.imageSelected = topic.picture;
    });
  }

  private getTopics(): void {
    this.listsService.getTopics().pipe(take(1)).subscribe(({
      next: ({ data }) => {
        this.topicsArr = data.filter((topic: Topic) => topic.topic !== 'Favoritos');
      }
    }));
  }

  private createForm(): void {
    this.nameList = this.fb.group({
      name: ['', [Validators.required]],
      topic: ['', [Validators.required]]
    });
  }

  public setEditValues(): void {
    this.nameList.patchValue({ name: this.data.name, topic: this.data.topic });
    this.imageSelected = this.data.picture;
  }

  public async createList(): Promise<void> {
    try {
      this.loading = true;
      const { name, topic } = this.nameList.value;
      const data = {
        name,
        type: 'BUYING-LIST',
        public: false,
        topic
      };
      await this.listsService.createList(data);
      this.snackbarService.openSnackbar('GENERAL.listCreated', 'success');
      this.loading = false;
      this.dialogRef.close(true);
      this.router.navigate(['/listas-alsuper']);
    } catch (error) {
      this.nameList.controls.name.setErrors({ wrong: true });
      this.loading = false;
    }
  }

  public async editList(): Promise<void> {
    try {
      this.loading = true;
      const { name, topic } = this.nameList.value;
      const data = {
        name,
        type: 'BUYING-LIST',
        public: false,
        topic
      };
      await this.listsService.editList(data, this.data.list_id);
      this.loading = false;
      this.dialogRef.close(true);
    } catch (error) {
      this.loading = false;
    }
  }

  ngOnDestroy(): void {
    this.subs.next();
    this.subs.complete();
  }

}
